(function () {
  'use strict';

  var STORAGE_KEY = 'mobilegs_attribution_v1';
  var CART_SYNC_HASH_KEY = 'mobilegs_attribution_cart_hash_v1';
  var VERSION = '2026-07-01-compact-v1';
  var ATTR_PREFIX = '__mg_';
  var STORAGE_TTL_DAYS = 90;
  var MAX_VALUE_LENGTH = 500;
  var CONSENT_FEATURE = {
    name: 'consent-tracking-api',
    version: '0.1',
  };

  var TRACKED_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_id',
    'utm_term',
    'utm_content',
    'utm_network',
    'utm_device',
    'utm_matchtype',
    'utm_account',
    'gclid',
    'gbraid',
    'wbraid',
  ];

  function nowIso() {
    return new Date().toISOString();
  }

  function addDays(date, days) {
    return new Date(date.getTime() + days * 24 * 60 * 60 * 1000).toISOString();
  }

  function truncate(value) {
    if (value == null) return '';
    value = String(value);
    return value.length > MAX_VALUE_LENGTH ? value.slice(0, MAX_VALUE_LENGTH) : value;
  }

  function safeParse(value) {
    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function readRecord() {
    var record = safeParse(window.localStorage.getItem(STORAGE_KEY));

    if (!record || !record.expires_at) {
      return null;
    }

    if (new Date(record.expires_at).getTime() <= Date.now()) {
      window.localStorage.removeItem(STORAGE_KEY);
      window.localStorage.removeItem(CART_SYNC_HASH_KEY);
      return null;
    }

    return record;
  }

  function writeRecord(record) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  }

  function getExternalReferrer() {
    if (!document.referrer) return '';

    try {
      var referrerUrl = new URL(document.referrer);

      if (referrerUrl.hostname === window.location.hostname) {
        return '';
      }

      return referrerUrl.href;
    } catch (error) {
      return '';
    }
  }

  function getLandingPage() {
    return window.location.pathname + window.location.search;
  }

  function hasTrackedParams(params) {
    return TRACKED_PARAMS.some(function (key) {
      return params.has(key);
    });
  }

  function touchHasTrackedParams(touch) {
    if (!touch) return false;

    return TRACKED_PARAMS.some(function (key) {
      return Boolean(touch[key]);
    });
  }

  function hasAttributionSignal(params, externalReferrer) {
    return hasTrackedParams(params) || Boolean(externalReferrer);
  }

  function buildTouch(params, timestamp, externalReferrer) {
    var touch = {
      seen_at: timestamp,
      landing_page: truncate(getLandingPage()),
      referrer: truncate(externalReferrer),
    };

    TRACKED_PARAMS.forEach(function (key) {
      touch[key] = truncate(params.get(key) || '');
    });

    return touch;
  }

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var externalReferrer = getExternalReferrer();

    if (!hasAttributionSignal(params, externalReferrer)) {
      return readRecord();
    }

    var timestamp = nowIso();
    var record = readRecord() || {
      version: VERSION,
      created_at: timestamp,
    };
    var touch = buildTouch(params, timestamp, externalReferrer);

    if (!record.first) {
      record.first = touch;
    }

    if (hasTrackedParams(params) || !touchHasTrackedParams(record.last)) {
      record.last = touch;
    }

    record.version = VERSION;
    record.updated_at = timestamp;
    record.expires_at = addDays(new Date(), STORAGE_TTL_DAYS);

    writeRecord(record);
    return record;
  }

  function addLegacyTouchAttributes(attributes, prefix, touch) {
    TRACKED_PARAMS.forEach(function (key) {
      attributes[ATTR_PREFIX + prefix + '_' + key] = touch ? truncate(touch[key]) : '';
    });

    attributes[ATTR_PREFIX + prefix + '_landing_page'] = touch ? truncate(touch.landing_page) : '';
    attributes[ATTR_PREFIX + prefix + '_referrer'] = touch ? truncate(touch.referrer) : '';
    attributes[ATTR_PREFIX + prefix + '_seen_at'] = touch ? truncate(touch.seen_at) : '';
  }

  function compactTouch(touch) {
    var compact = {};

    if (!touch) return compact;

    TRACKED_PARAMS.concat(['landing_page', 'referrer', 'seen_at']).forEach(function (key) {
      if (touch[key]) {
        compact[key] = truncate(touch[key]);
      }
    });

    return compact;
  }

  function touchAttributeValue(touch) {
    if (!touch) return '';

    return JSON.stringify(compactTouch(touch));
  }

  function clearLegacyExpandedAttributes(attributes) {
    addLegacyTouchAttributes(attributes, 'first', null);
    addLegacyTouchAttributes(attributes, 'last', null);
  }

  function buildCartAttributes(record) {
    var attributes = {};

    attributes[ATTR_PREFIX + 'attribution_version'] = VERSION;
    attributes[ATTR_PREFIX + 'first_touch'] = touchAttributeValue(record.first);
    attributes[ATTR_PREFIX + 'last_touch'] = touchAttributeValue(record.last);
    clearLegacyExpandedAttributes(attributes);

    return attributes;
  }

  function buildEmptyCartAttributes() {
    var attributes = {};

    attributes[ATTR_PREFIX + 'attribution_version'] = '';
    attributes[ATTR_PREFIX + 'first_touch'] = '';
    attributes[ATTR_PREFIX + 'last_touch'] = '';
    clearLegacyExpandedAttributes(attributes);

    return attributes;
  }

  function getCartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) {
      return window.routes.cart_update_url;
    }

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/update.js';
    }

    return '/cart/update.js';
  }

  function hashAttributes(attributes) {
    return JSON.stringify(attributes);
  }

  function needsCartSync(record) {
    if (!record || !record.first) return false;

    return window.localStorage.getItem(CART_SYNC_HASH_KEY) !== hashAttributes(buildCartAttributes(record));
  }

  function syncCartAttributes(options) {
    if (!attributionProcessingAllowed()) {
      return Promise.resolve(false);
    }

    var record = readRecord();

    if (!record || !record.first) {
      return Promise.resolve(false);
    }

    var attributes = buildCartAttributes(record);
    var hash = hashAttributes(attributes);

    if (!options || !options.force) {
      if (window.localStorage.getItem(CART_SYNC_HASH_KEY) === hash) {
        return Promise.resolve(true);
      }
    }

    return fetch(getCartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to sync attribution cart attributes.');
        }

        window.localStorage.setItem(CART_SYNC_HASH_KEY, hash);
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function clearCartAttributes() {
    if (!readRecord() && !window.localStorage.getItem(CART_SYNC_HASH_KEY)) {
      return Promise.resolve(false);
    }

    return fetch(getCartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ attributes: buildEmptyCartAttributes() }),
    })
      .then(function (response) {
        return response.ok;
      })
      .catch(function () {
        return false;
      })
      .finally(clearStoredAttribution);
  }

  function isCheckoutUrl(url) {
    if (!url) return false;

    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname === '/checkout' || parsed.pathname.indexOf('/checkout/') === 0;
    } catch (error) {
      return false;
    }
  }

  function isCheckoutSubmit(event) {
    var submitter = event.submitter;
    var form = event.target;

    if (!form || form.tagName !== 'FORM') return false;

    if (isCheckoutUrl(form.getAttribute('action'))) return true;

    if (!submitter) return false;

    var submitterName = submitter.getAttribute('name');
    var submitterValue = submitter.getAttribute('value');

    return submitterName === 'checkout' || submitterValue === 'checkout';
  }

  function withCartSyncedBeforeCheckout(event, continuation) {
    var record = readRecord();

    if (!record || !needsCartSync(record)) return false;

    event.preventDefault();
    event.stopImmediatePropagation();

    syncCartAttributes({ force: true }).then(continuation);
    return true;
  }

  function preserveSubmitter(form, submitter) {
    if (!form || !submitter || !submitter.name) return;

    var input = document.createElement('input');

    input.type = 'hidden';
    input.name = submitter.name;
    input.value = submitter.value || submitter.name;
    form.appendChild(input);
  }

  function bindCheckoutGuards() {
    document.addEventListener(
      'submit',
      function (event) {
        if (!isCheckoutSubmit(event)) return;

        var form = event.target;
        var submitter = event.submitter;

        withCartSyncedBeforeCheckout(event, function () {
          preserveSubmitter(form, submitter);
          HTMLFormElement.prototype.submit.call(form);
        });
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target.closest('a[href]');

        if (!target || !isCheckoutUrl(target.href)) return;

        withCartSyncedBeforeCheckout(event, function () {
          window.location.href = target.href;
        });
      },
      true
    );
  }

  function bindCartUpdates() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      window.setTimeout(function () {
        syncCartAttributes();
      }, 250);
    });
  }

  function getCustomerPrivacyApi() {
    return window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
  }

  function attributionProcessingAllowed() {
    var customerPrivacy = getCustomerPrivacyApi();

    if (!customerPrivacy) return true;

    if (typeof customerPrivacy.marketingAllowed === 'function') {
      return customerPrivacy.marketingAllowed();
    }

    if (typeof customerPrivacy.analyticsProcessingAllowed === 'function') {
      return customerPrivacy.analyticsProcessingAllowed();
    }

    return true;
  }

  function loadCustomerPrivacyApi(callback) {
    if (getCustomerPrivacyApi()) {
      callback();
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      callback();
      return;
    }

    window.Shopify.loadFeatures([CONSENT_FEATURE], function () {
      callback();
    });
  }

  function clearStoredAttribution() {
    window.localStorage.removeItem(STORAGE_KEY);
    window.localStorage.removeItem(CART_SYNC_HASH_KEY);
  }

  function captureAndSyncIfAllowed() {
    if (!attributionProcessingAllowed()) {
      clearCartAttributes();
      return;
    }

    var record = captureAttribution();

    if (record) {
      syncCartAttributes();
    }
  }

  function bindConsentUpdates() {
    document.addEventListener('visitorConsentCollected', function () {
      captureAndSyncIfAllowed();
    });
  }

  function init() {
    loadCustomerPrivacyApi(captureAndSyncIfAllowed);

    bindCartUpdates();
    bindCheckoutGuards();
    bindConsentUpdates();
  }

  window.MobilegsAttribution = {
    capture: captureAttribution,
    get: readRecord,
    syncCartAttributes: function () {
      return syncCartAttributes({ force: true });
    },
    attributionProcessingAllowed: attributionProcessingAllowed,
    clear: clearStoredAttribution,
  };

  init();
})();
